import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFamiconsSearchOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M32 0.5C36.1421 0.5 39.5 3.85786 39.5 8V32C39.5 36.1421 36.1421 39.5 32 39.5H0.5V0.5H32Z",
			fill: "#0A0A0A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32 0.5C36.1421 0.5 39.5 3.85786 39.5 8V32C39.5 36.1421 36.1421 39.5 32 39.5H0.5V0.5H32Z",
			stroke: "#0A0A0A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3636 11C16.9072 11 15.4835 11.4319 14.2726 12.241C13.0617 13.0501 12.1179 14.2001 11.5605 15.5457C11.0032 16.8912 10.8574 18.3718 11.1415 19.8002C11.4256 21.2286 12.1269 22.5406 13.1568 23.5704C14.1866 24.6003 15.4986 25.3016 16.927 25.5857C18.3554 25.8698 19.836 25.724 21.1815 25.1667C22.527 24.6093 23.6771 23.6655 24.4862 22.4546C25.2953 21.2437 25.7272 19.82 25.7272 18.3636C25.7271 16.4107 24.9512 14.5378 23.5703 13.1569C22.1894 11.776 20.3165 11.0001 18.3636 11Z",
			stroke: "#FAFAFA",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.8594 23.8574L29.002 29.0001",
			stroke: "#FAFAFA",
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		})
	]
});
export default SvgFamiconsSearchOutline;
